// Parsing and presenting money at the input edge. Everything stored stays in
// integer pence; we only convert to and from a human pounds string here.

/**
 * Parse a user-entered pounds string into integer pence, or null if invalid.
 * Accepts plain numbers ("950"), decimals ("950.5", "950.50"), a leading "£",
 * thousands commas, and an optional minus sign. Works in integer space so there
 * is no floating-point drift.
 */
export function poundsToPence(input: string): number | null {
  const cleaned = input.trim().replace(/[£,\s]/g, "");
  const match = /^(-?)(\d+)?(?:\.(\d{1,2}))?$/.exec(cleaned);
  if (!match) {
    return null;
  }
  const [, sign, whole, fraction] = match;
  // Reject empty input and a lone "." or "-".
  if (whole === undefined && fraction === undefined) {
    return null;
  }
  const pounds = whole ? Number.parseInt(whole, 10) : 0;
  const pence = fraction ? Number.parseInt(fraction.padEnd(2, "0"), 10) : 0;
  const total = pounds * 100 + pence;
  return sign === "-" ? -total : total;
}

/**
 * Render integer pence as an editable pounds string, for example 95050 ->
 * "950.50". Integer-based so it is exact for any amount.
 */
export function penceToPoundsInput(pence: number): string {
  const sign = pence < 0 ? "-" : "";
  const abs = Math.abs(pence);
  const pounds = Math.trunc(abs / 100);
  const pennies = abs % 100;
  return `${sign}${pounds}.${String(pennies).padStart(2, "0")}`;
}
